




import Vue from 'vue';
import UsersDelete from '@/components/users/user-delete.component.vue';

export default Vue.extend({
  components: {
    'user-delete': UsersDelete
  }
});
